var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mobile-back-btn-secondary-nav-container" },
    [
      _c("router-link", {
        attrs: { to: { name: "FileList", params: { uuid: _vm.id } } },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ href, route, navigate, isActive, isExactActive }) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "mobile-back-btn-secondary-nav",
                    on: { click: navigate },
                  },
                  [
                    _c("i", { staticClass: "fa lh-inherit fa-arrow-left" }),
                    _vm._v(" " + _vm._s(_vm._f("trans")("Back")) + "\n    "),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }